{
  "RESET_PASSWORD": {
    "TITLE": "Redefinir senha",
    "DESCRIPTION": "Digite o endereço de e-mail que você usa para acessar o Chatwoot para obter as instruções de redefinição da senha.",
    "GO_BACK_TO_LOGIN": "Se você quiser voltar para a página de acesso,",
    "EMAIL": {
      "LABEL": "E-mail",
      "PLACEHOLDER": "Por favor, digite seu e-mail.",
      "ERROR": "Por favor, insira um e-mail válido."
    },
    "API": {
      "SUCCESS_MESSAGE": "O link para alteração de senha foi enviado para seu e-mail.",
      "ERROR_MESSAGE": "Não foi possível conectar ao servidor Chatwoot. Por favor, tente novamente."
    },
    "SUBMIT": "Enviar"
  }
}
